import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { Workflow } from '@awork/features/workflow/models/workflow.model'

@Injectable({ providedIn: 'root' })
export class WorkflowStore extends EntitySignalStore<Workflow> {
  constructor() {
    super({ name: 'workflow', entityConstructor: workflow => new Workflow(workflow) })
  }
}
